import { merge } from 'lodash-es';
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState({
            slices: (state) => state.slices.items || {},
        }),
    },

    methods: {
        getPresetForm(name) {
            return (name && this.slices[name]?.form) || {};
        },

        collectPresetNames(form) {
            const steps = form?.registration?.steps || [];
            const stepPresetNames = steps.map((item) => item.form?.presetName);
            return [...new Set([form?.presetName, ...stepPresetNames].filter(Boolean))];
        },

        loadPresets(form, locale) {
            const names = this.collectPresetNames(form).filter((slice) => !this.slices[slice]);
            return Promise.all(
                names.map((slice) => this.$store.dispatch('slices/getSyncedData', { slice, locale })),
            );
        },

        resolvePresets(form) {
            if (!form) return form;

            const resolved = merge({}, this.getPresetForm(form.presetName), form);
            const steps = resolved.registration?.steps;

            if (Array.isArray(steps)) {
                resolved.registration.steps = steps.map((step) => {
                    if (!step.form?.presetName) return step;
                    return { ...step, form: merge({}, this.getPresetForm(step.form.presetName), step.form) };
                });
            }

            return resolved;
        },

        resolveStepForm(form, step) {
            const resolved = this.resolvePresets(form);
            if (!resolved) return resolved;
            const stepForm = resolved.registration?.steps?.[step]?.form;
            return stepForm ? merge({}, resolved, stepForm) : resolved;
        },
    },
};
